import useAllViewerShops from "@babackapp/private-api-client/client/use-all-viewer-shops";
import { Navigate } from "react-router-dom";
import { HomeLoading } from "@/components/home-loading";
import { NoShopFound } from "./components/no-shop-found";

export default function ShopsPage() {
	const { data: shops, isPending } = useAllViewerShops();
	if (isPending) return <HomeLoading />;
	if (!shops || shops.length === 0) return <NoShopFound />;
	return <Navigate to={`/shops/${shops?.[0].id}`} replace />;
}
